import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TOURS } from "@/constants/testIds";

export default function TourCard({ tour, index = 0 }) {
  const accent =
    tour.category === "College Tour"
      ? { tag: "bg-coral/15 text-coralDeep", ring: "hover:ring-coral" }
      : tour.category === "Educator Group"
      ? { tag: "bg-teal/15 text-teal", ring: "hover:ring-teal" }
      : { tag: "bg-sun/30 text-ink", ring: "hover:ring-sun" };

  return (
    <Link
      to={`/tours/${tour.slug}`}
      data-testid={TOURS.cardLink(tour.slug)}
      className={`group block bg-white rounded-3xl overflow-hidden ring-1 ring-ink/8 transition-all duration-300 hover:-translate-y-1 hover:soft-shadow hover:ring-2 ${accent.ring}`}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="overflow-hidden image-zoom-host relative">
        <img
          src={tour.hero_image}
          alt={tour.title}
          className="image-zoom w-full h-64 object-cover"
          loading="lazy"
        />
        <span className={`absolute top-4 left-4 chip ${accent.tag} backdrop-blur-md`}>
          {tour.category}
        </span>
        <span className="absolute top-4 right-4 chip bg-white/95 text-ink">
          {tour.duration_days} Days
        </span>
      </div>
      <div className="p-6">
        <h3 className="display-serif text-2xl leading-tight mb-2">{tour.title}</h3>
        <div className="font-mono text-xs uppercase tracking-[0.18em] text-muted2 mb-3">
          {tour.destination}
        </div>
        <p className="text-sm text-muted2 leading-relaxed line-clamp-2 mb-5">{tour.summary}</p>
        <div className="flex items-center justify-between pt-4 border-t border-ink/8">
          <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink/55">
            Min · {tour.min_group_size} guests
          </span>
          <span className="inline-flex items-center gap-1.5 text-coral text-sm font-semibold group-hover:gap-2.5 transition-all">
            See itinerary <ArrowRight size={14} />
          </span>
        </div>
      </div>
    </Link>
  );
}
